import { PencilLine } from 'lucide-react'
import featureFlags from '@/utils/feature-flags'

export default {
	icon:  PencilLine,
	name: 'Inscribe',
	onClick: ({ router, onClose }: any) => {
		router.push('/inscribe')
		onClose()
	},
	featured: true,
	filter: ({ loggedIn: _loggedIn }: any) => {
		return !featureFlags('app::disable_inscribe')
	}
}
